import React from 'react';

export function badge() {
  return (
    <svg viewBox='0 0 39 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_331_735)'>
        <path d='M4 2H35V40L19.5 32.5L4 40V2Z' fill='#FFCA3A' />
      </g>
      <defs>
        <filter id='filter0_d_331_735' x='0' y='0' width='39' height='46' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_331_735' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_331_735' result='shape' />
        </filter>
      </defs>
    </svg>
  );
}
